import noop from 'lodash/noop'
import { createContext } from 'react'

import { PagePresentation, PageType } from '@Generated/graphql'

export type CMSModalState = [
  { id: string, presentation: PagePresentation, type: PageType } | undefined,
  (type: PageType, id: string, sourceID?: string, presentation?: PagePresentation) => void,
  () => void,
]

export const CMSModalContext = createContext<CMSModalState>([undefined, noop, noop])
